import { render } from "./previewImage.vue?vue&type=template&id=596ae8d4&scoped=true"
import script from "./previewImage.vue?vue&type=script&lang=js"
export * from "./previewImage.vue?vue&type=script&lang=js"

import "./previewImage.vue?vue&type=style&index=0&id=596ae8d4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596ae8d4"]])

export default __exports__